import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;

    h3 {
        margin-top: 42px;
        padding-bottom: 25px;
    }
`;

export const JsonTextarea = styled.textarea`
    width: 100%;
    min-height: 280px;
    font-family: 'Consolas', 'Monaco', monospace;
    font-size: 13px;
    padding: 12px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    resize: vertical;
`;

export const TreeShell = styled.div`
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    margin-top: 1rem;
`;

export const TreeHeaderBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #102a63;
    color: #fff;
    padding: 10px 14px;
    min-height: 44px;
`;

export const TreeHeaderTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    font-size: 15px;
`;

export const TreeHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const TreeBodyPanel = styled.div`
    padding: 8px 0 12px;
    min-height: 120px;
    background: #fff;
`;

export const TreeRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 38px;
    padding: 4px 12px 4px ${({ $depth }) => 12 + ($depth || 0) * 20}px;
    border-left: ${({ $depth }) =>
        ($depth || 0) > 0 ? `2px solid #e9ecef` : '2px solid transparent'};
    margin-left: ${({ $depth }) => ($depth || 0) > 0 ? '0' : '0'};
    gap: 8px;

    &:hover {
        background: #f8f9fa;
    }
`;

export const TreeRowMain = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: 6px;
`;

export const TreeExpandSlot = styled.span`
    flex-shrink: 0;
    width: 24px;
    display: inline-flex;
    justify-content: center;
`;

export const TreeExpandBtn = styled.button`
    width: 22px;
    height: 22px;
    padding: 0;
    line-height: 1;
    font-size: 14px;
    border: 1px solid #adb5bd;
    border-radius: 3px;
    background: #fff;
    color: #495057;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #e9ecef;
    }
`;

export const TreeIconSlot = styled.span`
    flex-shrink: 0;
    color: #6c757d;
    font-size: 15px;
    display: inline-flex;
`;

export const TreeLabel = styled.span`
    font-size: 14px;
    color: #212529;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const TreeActionsRail = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    flex-shrink: 0;
    width: 260px;
`;

export const TypePill = styled.span`
    display: inline-block;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 11px;
    padding: 3px 10px;
    border-radius: 999px;
    background: #e9ecef;
    color: #495057;
    border: 1px solid #dee2e6;
`;

export const IconBtn = styled.button`
    border: none;
    background: transparent;
    color: #868e96;
    padding: 6px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: #495057;
        background: #e9ecef;
    }
`;

export const EmptyTreeHint = styled.p`
    margin: 16px 14px;
    color: #6c757d;
    font-size: 14px;
`;

export const TreeHeaderIconBtn = styled.button`
    border: 1px solid rgba(255, 255, 255, 0.45);
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    padding: 6px 10px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgba(255, 255, 255, 0.22);
        color: #fff;
    }
`;
